import React from 'react'
import Modal from '../../modals/wrapper'
import CSVImporter from '../../common/csv-importer'
import { Button } from 'react-bootstrap'
import useSyncRedemptions from './use-sync-redemptions'

const fieldsConfig = [
    { label: 'Code', value: 'id', required: true },
    { label: 'URL', value: 'url', required: true },
]

const IOSUpdateModal = ({
    onClose = () => {},
}) => {

    const {
        setRedemptions,
        saveRedemptions,
        canSave
    } = useSyncRedemptions({
        onSuccess: onClose
    })

    return (
        <Modal
            onHide={onClose}
            full
            closeButton
        >
            <div
                style={{ padding: '20px'}}
            >

            
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <h2>Upload iOS redemption CSV</h2>
                </div>

                <CSVImporter
                    onChange={setRedemptions}
                    fields={fieldsConfig}
                />

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end'
                    }}
                >
                    <Button
                        onClick={() => saveRedemptions()}
                        disabled={!canSave}
                    >
                        Upload
                    </Button>
                </div>
            </div>
            

        </Modal>
    )
}

export default IOSUpdateModal
